import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Building2 } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ResetPassword() {
  const nav = useNavigate();
  const token = new URLSearchParams(window.location.search).get("token") || "";
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password updated — please sign in");
      nav("/login");
    } catch (err) { toast.error(apiError(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center noise-bg bg-background p-6">
      <form onSubmit={submit} className="w-full max-w-sm bg-white border border-border rounded-md p-8">
        <div className="flex items-center gap-2 mb-6">
          <div className="h-9 w-9 rounded-md bg-[#18181A] flex items-center justify-center"><Building2 className="h-5 w-5 text-white" /></div>
          <span className="font-head text-xl font-extrabold tracking-tight">Bides</span>
        </div>
        <h1 className="font-head text-2xl font-extrabold tracking-tight">Set a new password</h1>
        {!token && <p className="text-sm text-[#9E382A] mt-2">Missing reset token. Use the link from your email.</p>}
        <Label className="overline mt-5 block">New password</Label>
        <Input data-testid="reset-password-input" type="password" value={pw} onChange={(e) => setPw(e.target.value)} className="mt-1.5" required minLength={6} />
        <Button data-testid="reset-submit-button" type="submit" disabled={loading || !token} className="w-full mt-5">{loading ? "Please wait…" : "Update password"}</Button>
        <button type="button" onClick={() => nav("/login")} className="mt-4 text-sm text-muted-foreground hover:text-foreground w-full text-center">Back to sign in</button>
      </form>
    </div>
  );
}
